import { Pipe, PipeTransform } from '@angular/core';
import { StudyFile } from 'src/app/models/Study/study-file.model';

@Pipe({
  name: 'sortStudiesByCategoryPipe',
  pure: false,
})
export class SortStudiesByCategoryPipePipe implements PipeTransform {
  transform(studyFiles: StudyFile[]): any {
    return studyFiles.sort((a, b) => {
      if (a.mediaCategoryId < b.mediaCategoryId) {
        return 1;
      } else if (a.mediaCategoryId === b.mediaCategoryId) {
        return 0;
      } else {
        return -1;
      }
    });
  }
}
